import Footer from "./Footer";
import Navbar from "./Navbar";
import { Box, Button, Link } from '@chakra-ui/react'
import { MDBCol, MDBContainer, MDBRow, MDBCard, MDBCardText, MDBCardBody, MDBCardImage, MDBTypography, MDBIcon } from 'mdb-react-ui-kit';
import { useState } from "react";
import { useEffect } from "react";
import { useContext } from "react";
import { AuthContext } from "../Context/ContextProvider";
import { Navigate, NavLink } from "react-router-dom";

function UserPage() {
    const {HandleLogout}=useContext(AuthContext);
    const  token= localStorage.getItem("token");
    const username=localStorage.getItem("username") || false;
    const [userData,setData]=useState({});

    
    useEffect(()=>{
      getUser();
    },[])


    const getUser=async()=>{
        const userdetail=await fetch(`https://masai-api-mocker.herokuapp.com/user/${username}`,{
            method:"GET",
            headers:{
              "Authorization" : `Bearer ${token} `
            }
        })
        const res2=await userdetail.json();
        setData(res2)
      }    

      const handleClick=()=>{
        HandleLogout();
      }

      
  

    return ( 
       <>
       <section className="vh-100" style={{ backgroundColor: '#f4f5f7' }}>
      <MDBContainer className="py-5 h-100">
        <MDBRow className="justify-content-center align-items-center h-100"  >
          <MDBCol lg="6" className="mb-4 mb-lg-0" >
            <MDBCard className="mb-3" style={{ borderRadius: '.5rem' }}>
              <MDBRow className="g-0">
                <MDBCol md="4" className="gradient-custom text-center text-white"
                  style={{ borderTopLeftRadius: '.5rem', borderBottomLeftRadius: '.5rem' }}>
                  <MDBCardImage  src="https://mdbcdn.b-cdn.net/img/Photos/new-templates/bootstrap-chat/ava1-bg.webp"
                    alt="Avatar" className="my-5" style={{ width: '80px' }} fluid />
                  <MDBTypography tag="h5">{userData.name}</MDBTypography>
                  <MDBCardText>{userData.description}</MDBCardText>
                  <MDBIcon far icon="edit mb-5" />
                </MDBCol>
                <MDBCol md="8">
                  <MDBCardBody className="p-4">

                    <MDBTypography tag="h6">Information</MDBTypography>
                    <hr className="mt-0 mb-4" />
                    <MDBRow className="pt-1">
                      <MDBCol size="6" className="mb-3">
                        <MDBTypography tag="h6">Email</MDBTypography>
                        <MDBCardText className="text-muted">{userData.email}</MDBCardText>
                      </MDBCol>
                      <MDBCol size="6" className="mb-3">
                        <MDBTypography tag="h6">Phone</MDBTypography>
                        <MDBCardText className="text-muted">{userData.mobile}</MDBCardText>
                      </MDBCol>
                    </MDBRow>

                    <div className="d-flex justify-content-start">
                      <a href="#!"><MDBIcon fab icon="facebook me-3" size="lg" /></a>
                      <a href="#!"><MDBIcon fab icon="twitter me-3" size="lg" /></a>
                      <a href="#!"><MDBIcon fab icon="instagram me-3" size="lg" /></a>
                      <Box as="button" onClick={handleClick} >LOG OUT</Box>
                      <NavLink to='/admin/form' ><Button>ADMIN PAGE</Button></NavLink>
                    </div>
                  </MDBCardBody>
                </MDBCol>
              </MDBRow>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </section>
       </>
     );
}

export default UserPage;